import { taskIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const completeCycleCount = {
  name: "completeCycleCount" as const,
  input: z.object({ taskId: taskIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
